// extracted by mini-css-extract-plugin
module.exports = {"component":"debug-bar_component__hRJyp","expanded":"debug-bar_expanded__n6PtR"};